import { normalizeText } from './text'

export function extractSpecificationNumbers(value: unknown): readonly string[] {
  const matches = normalizeText(value).match(/\d+(?:\.\d+)?/gu) ?? []
  return [...new Set(matches)].sort()
}

/**
 * Creates deterministic indexing tokens. CJK bigrams make candidate lookup
 * useful even when descriptions contain no spaces.
 */
export function extractSearchTokens(...values: readonly unknown[]): readonly string[] {
  const tokens = new Set<string>()

  for (const value of values) {
    const text = normalizeText(value)
    if (!text) continue

    for (const part of text.match(/[\p{Script=Han}]+|[\p{L}\p{N}]+/gu) ?? []) {
      tokens.add(part)
      if (/^\p{Script=Han}+$/u.test(part) && part.length > 1) {
        for (let index = 0; index < part.length - 1; index += 1) {
          tokens.add(part.slice(index, index + 2))
        }
      }
    }

    for (const number of extractSpecificationNumbers(text)) tokens.add(`#${number}`)
  }

  return [...tokens].filter((token) => token.length > 1).sort()
}
